import { Dataset } from '../types/types';

export const canExportDataset = (dataset: Dataset | undefined): boolean =>
  dataset?.exportable !== false;
